import { APICore } from './apiCore'

const api = new APICore()

function getSeaConfigs (params) {
  const baseUrl = '/sea-config'
  return api.get(baseUrl, params)
}

function getSeaConfig (id) {
  const baseUrl = `/sea-config/${id}`
  return api.get(baseUrl, {})
}

function addSeaConfig (params) {
  const baseUrl = '/sea-config'
  return api.createWithFile(baseUrl, params)
}

function updateSeaConfig (params) {
  const baseUrl = '/sea-config'
  return api.updateWithFile(baseUrl, params)
}

function deleteSeaConfig (params) {
  const baseUrl = '/sea-config'
  return api.delete(baseUrl, params)
}

export { getSeaConfigs, getSeaConfig, addSeaConfig, updateSeaConfig, deleteSeaConfig }
